/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Bид для элемента паджинации.
   */
  app.PaginationView = app.BasePaginationView.extend({

    el: '.b-pagination',
    separator: '...',
    maxButtonsCount: 6,
    minButtonCount: 5,
    nextPageLabel: '&rarr;',
    nextPageCssClass: 'b-pagination__page b-pagination__control',
    prevPageLabel: '&larr;',
    prevPageCssClass: 'b-pagination__page b-pagination__control',
    activePageCssClass: 'b-pagination__page b-pagination__page_selected',
    separatorPageCssClass: 'b-pagination__page_space',
    firstPageLabel: false,
    firstPageCssClass: 'first',
    lastPageLabel: false,
    lastPageCssClass: 'last',
    router: false,

    run: function (options) {
      this.btnView = app.PaginationButtonView;
      if (options && options.btnView) {
        this.btnView = options.btnView;
      }
      this.listenTo(this.model, 'sync search-collection:reset', this.render);
    },

    render: function () {
      var pageCount = this.model.state.totalPages;
      if (this._needClear(pageCount)) {
        this.$el.html('');
        return this;
      }
      this.$el.html(this._renderButtonList(pageCount));
      return app.BasePaginationView.prototype.render.apply(this, arguments);
    },
    _change: function () {
      var page = parseInt(this.$('.js-select-page-input').val(), 10),
        path = '/';
      if (page && page !== this.model.state.currentPage) {
        if (page !== 1) {
          path = '/p' + page;
        }
        this.router.navigate(path, {trigger: true}, {});
      }
    },
    _needClear: function (pageCount) {
      return pageCount < 2 || this.model.mode === 'infinite';
    },
    _renderButtonList: function (pageCount) {
      var buttons = [],
        currentPage = this.model.state.currentPage - 1,
        page;
      if (currentPage > pageCount) {
        currentPage = pageCount;
      }
      // Добавляем кнопку первая, если необходимо
      if (this.firstPageLabel !== false) {
        buttons.push(this._getPageButton(this.firstPageLabel, 1, this.firstPageCssClass, currentPage <= 0));
      }
      // Добавляем кнопку предыдущая, если необходимо
      if (this.prevPageLabel !== false) {
        if ((page = currentPage) <= 0) {
          page = 1;
        }
        buttons.push(this._getPageButton(this.prevPageLabel, page, this.prevPageCssClass, currentPage <= 0));
      }
      // Определяем промежуток для создания промежуточных страниц
      var range = this._getPageRange(),
        beginPage = range[0],
        endPage = range[1],
        startSeparator = false,
        endSeparator = false;
      beginPage++;
      endPage--;
      if (beginPage !== 1) {
        startSeparator = true;
        beginPage++;
      }
      if (endPage + 1 !== pageCount - 1) {
        endSeparator = true;
        endPage--;
      }
      // Добавляем первую страницу
      buttons.push(this._getPageButton(1, 1, (0 === currentPage ? this.activePageCssClass : 'b-pagination__page'), false));
      // Добавляем разделитель, если необходимо
      if (startSeparator) {
        buttons.push(this._getPageButton(this.separator, null, this.separatorPageCssClass, false));
      }
      // Добавляем промежуточные страницы в цикле исходя из начальной и конечной страницы промежутка
      for (var i = beginPage; i <= endPage; i++) {
        if (i !== 0 && i !== pageCount - 1) {
          buttons.push(this._getPageButton(i + 1, i + 1, (i === currentPage ? this.activePageCssClass : 'b-pagination__page'), false));
        }
      }
      // Добавляем разделитель, если требуется
      if (endSeparator) {
        buttons.push(this._getPageButton(this.separator, null, this.separatorPageCssClass, false));
      }
      // Добавляем последнюю страницу
      buttons.push(this._getPageButton(pageCount, pageCount, (pageCount - 1 === currentPage ? this.activePageCssClass : 'b-pagination__page'), false));
      // Добавляем кнопку следующая, если необходимо
      if (this.nextPageLabel !== false) {
        if ((page = currentPage + 1) >= pageCount - 1) {
          page = pageCount - 1;
        }
        buttons.push(this._getPageButton(this.nextPageLabel, page + 1, this.nextPageCssClass, currentPage >= pageCount - 1));
      }
      // Добавляем кнопку последняя, если необходимо
      if (this.lastPageLabel !== false) {
        buttons.push(this._getPageButton(this.lastPageLabel, pageCount - 1, this.lastPageCssClass, currentPage >= pageCount - 1));
      }
      // Рендерим результат
      var result = [];
      _.each(buttons, function (button) {
        result.push(button.render().$el);
      });
      return result;
    },
    /**
     * Создает объект app.PaginationButtonView с необходимыми параметрами
     * @param label Лэйбл кнопки
     * @param page Страница кнопки
     * @param buttonClass Класс кнопки
     * @param disabled Неактивна?
     * @returns app.PaginationButtonView Инициализированнный объект кнопки
     * @private
     */
    _getPageButton: function (label, page, buttonClass, disabled) {
      return new this.btnView({
        model: this.model,
        label: label,
        page: page,
        buttonClass: buttonClass,
        disabled: disabled,
        parentView: this,
        router: this.router
      });
    },
    /**
     * Получает начальную страницу и конечную, для формирования промежуточных страниц
     * @returns {*[]} Массив со значениями начальной и конечной страницы
     * @private
     */
    _getPageRange: function () {
      var currentPage = this.model.state.currentPage - 1,
        pageCount = this.model.state.totalPages,
        beginPage = Math.max(0, currentPage - Math.floor(this.maxButtonsCount / 2)),
        endPage = currentPage + Math.floor(this.maxButtonsCount / 2) + 1;
      if (currentPage === 0 && endPage < this.minButtonCount) {
        endPage = beginPage + this.minButtonCount;
      }
      if (endPage >= pageCount) {
        endPage = pageCount - 1;
        beginPage = Math.max(0, endPage - (this.maxButtonsCount + 1));
      }
      return [beginPage, endPage];
    },
    /**
     * Формирует объект с параметрами для рендеринга формы выбора страницы
     * @returns {{min: number, max: number}}
     * @private
     */
    _getRenderParams: function () {
      return {
        min: 1,
        max: this.model.state.totalPages
      };
    }
  });
})();

}.call(window));